var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"loading"}},[_c('vue-loaders-ball-pulse-sync',{attrs:{"color":"#000","scale":_vm.size}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }